// extracted by mini-css-extract-plugin
module.exports = {"layout":"HouseDesktop_layout__4ihNr","content-container":"HouseDesktop_content-container__iuONo","price-box":"HouseDesktop_price-box__p72ax"};